import Vue from 'vue'
import Router from 'vue-router'
import Landing from 'pages/landing/Landing'
import Register from 'pages/landing/user/Register'
import SignIn         from 'pages/landing/user/SignIn.vue';
import ForgotPassword from 'pages/landing/user/ForgotPassword.vue';
import NewPassword from 'pages/landing/user/NewPassword.vue';
import Profile from 'pages/landing/user/Profile.vue';
import Dashboard from 'pages/landing/user/Dashboard.vue';
import AccountConfirmation from 'pages/landing/user/AccountConfirmation.vue';
import XeroGateway from 'pages/landing/user/XeroGateway.vue';

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'default',
      component: Landing
    },
    {
      path: '/signin',
      name: 'signin',
      component: SignIn
    },
    {
      path: '/user/reset-password',
      name: 'forgotpassword',
      component: ForgotPassword
    },
    {
      path: '/user/new-password',
      name: 'newpassword',
      component: NewPassword
    },
    {
      path: '/user/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '/user/confirmation',
      name: 'account-confirmation',
      component: AccountConfirmation 
    },
    {
      path: '/user/dashboard',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/user/register',
      name: 'register',
      component: Register
    },
    {
      path: '/user/xerogateway',
      name: 'xerogateway',
      component: XeroGateway
    }
  ]
})
